import React, { Component } from 'react';
import styled from 'styled-components';

import api from 'api';
import WP from 'WP';

import DropdownList from './DropdownList';
import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Html from 'partials/Html';
import Button from 'partials/Button';

import Media from 'css/Media';

const InputField = props => {
    const getErrorText = () => {
        switch(props.id) {
            case 'email':
                return <p>{WP.trans.invalidEmail}</p>;
            case 'phone':
                return <p>{WP.trans.invalidTel}</p>;
            default: 
                return <p>{WP.trans.invalidBlank} {props.label.toLowerCase()}</p>
        }
    }
    return(
        <StyledLabel id={props.id} validated={props.validated} className={props.className}>
            <p>{props.label}</p>
            <input 
                type={props.type} 
                name={props.id} 
                onChange={props.onChange}
                onBlur={props.onBlur}
                value={props.value}
            />
            {!props.validated && getErrorText()}
        </StyledLabel>
    )
}

class RegistrationForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            numPersons: null,
            validEmailFormat: true,
            submitted: false,
            disabled: false,
            validated: false,
        }
    }

    handleOnChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleNumPersonsChange(e) {
        this.setState({
            numPersons: e
        });
    }

    validateEmailFormat = (e) => {
        
        let regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.setState({
            validEmailFormat: regEx.test(String(e.target.value).toLowerCase())
        })
    }

    handleSubmit = () => {

        if(this.state.firstName.length && this.state.lastName.length && this.state.email.length && this.state.validEmailFormat && this.state.phone.length && this.state.numPersons > 0) {
            api.sendEventBookingEmail({
                bookingEmail: this.props.data.acf.booking_email,
                event: this.props.data.acf.title,
                name: this.state.firstName + ' ' + this.state.lastName,
                email: this.state.email,
                phone: this.state.phone,
                numPersons: this.state.numPersons
            }).then(resp => {
                if(resp.data) {
                    this.setState({submitted: true})
                }
            });
            this.setState({disabled: true});
        } else console.log('invalid')
    }

    render() {
        const { data } = this.props;
        const {
            firstName,
            lastName,
            email,
            phone,
            numPersons,
            validEmailFormat,
            submitted,
            disabled
        } = this.state;

        return (
            <Wrapper>
                <Container grid>
                    <OuterGridElement
                        colStart={{default: 1, s: 5}}
                        colEnd={{default: 8, s: 20}}
                    >
                        <InnerGrid>
                            <TitleGridElement
                                colStart={{default: 1, s: 3, m: 3}}
                                colEnd={{default: 8, s: 14, m: 14}}
                                rowStart={{default: 1}}
                            >
                                <h4>{data.acf.form_title}</h4>
                            </TitleGridElement>
                            <InputGridElement
                                colStart={{default: 1, s: 3, m: 3}}
                                colEnd={{default: 8, s: 14, m: 8}}
                                rowStart={{default: 2}}
                            >
                                <DropdownList 
                                    value={numPersons}
                                    onChange={e => this.handleNumPersonsChange(e)}
                                />
                            </InputGridElement>
                            <InputGridElement
                                colStart={{default: 1, s: 3, m: 3}}
                                colEnd={{default: 8, s: 14, m: 8}}
                                rowStart={{default: 3}}
                            >
                                <InputField 
                                    id="firstName"
                                    label={WP.trans.firstName}
                                    type="text"
                                    onChange={(e) => this.handleOnChange(e)}
                                    value={firstName}
                                    validated={firstName.length > 0 || !submitted}
                                />
                            </InputGridElement>
                            <InputGridElement
                                colStart={{default: 1, s: 3, m: 9}}
                                colEnd={{default: 8, s: 14, m: 14}}
                                rowStart={{default: 4, m: 3}}
                            >
                                <InputField 
                                    id="lastName"
                                    label={WP.trans.lastName}
                                    type="text"
                                    onChange={(e) => this.handleOnChange(e)}
                                    value={lastName}
                                    validated={lastName.length > 0 || !submitted}
                                />
                            </InputGridElement>
                            <InputGridElement
                                colStart={{default: 1, s: 3, m: 3}}
                                colEnd={{default: 8, s: 14, m: 8}}
                                rowStart={{default: 5, m: 4}}
                            >
                                <InputField 
                                    id="email"
                                    label={WP.trans.email}
                                    type="email"
                                    onChange={(e) => this.handleOnChange(e)}
                                    onBlur={(e) => this.validateEmailFormat(e)}
                                    value={email}
                                    validated={(validEmailFormat && !submitted) || (validEmailFormat && email.length && submitted)}
                                />
                            </InputGridElement>
                            <InputGridElement
                                colStart={{default: 1, s: 3, m: 9}}
                                colEnd={{default: 8, s: 14, m: 14}}
                                rowStart={{default: 6, m: 4}}
                            >
                                <InputField 
                                    id="phone"
                                    label={WP.trans.phone}
                                    type="tel"
                                    onChange={(e) => this.handleOnChange(e)}
                                    value={phone}
                                    validated={phone.length > 0 || !submitted}
                                />
                            </InputGridElement>
                            { data.acf.form_text_content &&
                                <HtmlGridElement
                                    colStart={{default: 1, s: 3}}
                                    colEnd={{default: 8, s: 14}}
                                    rowStart={{default: 7, m: 5}}
                                >
                                <Html content>{data.acf.form_text_content}</Html>
                            </HtmlGridElement>}
                            <InputGridElement
                                colStart={{default: 1, s: 5, m: 11}}
                                colEnd={{default: 4, s: 12, m: 14}}
                                colSpan
                                rowStart={{default: 8, m: 6}}
                                align="center"
                            >
                                <Button onClick={disabled ? null : () => this.handleSubmit()}>
                                    { disabled ? 
                                        WP.trans.thanks : 
                                        WP.trans.sendRegistration
                                    }
                                    
                                </Button>
                            </InputGridElement>
                        </InnerGrid>
                    </OuterGridElement>
                </Container>
            </Wrapper>
        )
    }
}


export default RegistrationForm;

const Wrapper = styled.section`
    margin-bottom: ${props => props.theme.spacing.elementM};

    ${Media.greaterThan('s')`
        margin-bottom: ${props => props.theme.spacing.blockL};
    `}
`

const OuterGridElement = styled(GridElement)`

    ${Media.greaterThan('s')`
        padding: ${props => props.theme.spacing.elementL} 0 ${props => props.theme.spacing.blockM};
        border: 1px solid ${props => props.theme.colors.text};
    `}
`

const InnerGrid = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .359fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .359fr) 1fr;
    -ms-grid-rows: ${props => props.rows || 'auto'};
    grid-template-rows: ${props => props.rows || 'auto'};

    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .67fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .67fr) 1fr;
    `}

    ${Media.greaterThan('m')`
        -ms-grid-columns: (1fr .435fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .435fr) 1fr;
    `}

    /* ${Media.greaterThan('l')`
        -ms-grid-columns: (1fr .322fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .322fr) 1fr;
    `} */
`

const TitleGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementM};
    `}
`

const InputGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};
    
    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};

        &:last-of-type {
            padding-bottom: ${props => props.theme.spacing.elementM};
        }
    `}
`

const HtmlGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.blockXS};
    `}
`

const StyledLabel = styled.label`
    p {
        ${Media.greaterThan('s')`
            font-size: 18px;
            line-height: 22px;
            padding: 0 0 ${props => props.theme.spacing.contentM} ${props => props.theme.spacing.contentM};
        `}
    }

    >p:first-of-type {
        color: ${props => props.theme.colors.inputText};
    }

    input {
        ~ p {
            color: ${props => props.theme.colors.danger};
            font-size: 14px;
            line-height: 16px;
            padding-top: ${props => props.theme.spacing.contentS};

            ${Media.greaterThan('s')`
                font-size: 16px;
            `}
        }
    }

    input[type="text"],
    input[type="email"],
    input[type="number"],
    input[type="tel"] {
        width: 100%;
        height: ${props => props.theme.spacing.elementS};
        border: 1px solid ${props => props.validated ? props.theme.colors.input : props.theme.colors.danger};
        box-shadow: none;
        -webkit-appearance: none;
        border-radius: 0;
        ${props => props.theme.fonts.p};
        font-size: 14px;
        padding: 0 25px;
        background-color: ${props => props.theme.colors.negative};
        transition: border .2s ease;

        &:hover,
        &:focus-within {
            border-color: ${props => props.theme.colors.text};
        }

        ${Media.greaterThan('s')`
            font-size: 16px;
        `}
    }
`